module.exports = __webpack_public_path__ + "img/RJC_logo_dark.f1f83613.png";